import { FormikConfig } from 'formik';
import {
  RegisterBusinessMutationVariables,
} from 'Generated/graphql';
import * as yup from 'yup';

const signUpFormValidationSchema = {
  idToken: yup.string().required(),
  timezoneLocation: yup.string().required(),
  business: yup.object({
    name: yup.string().required(
      'Please enter your business or property name',
    ),
    numEmployees: yup.number().min(0).required(
      'Please enter the estimated number of residents',
    ),
    type: yup.string().required(
      'Please select business type',
    ),
  })
};

export const signupFormValidationSchema = yup.object(
  signUpFormValidationSchema,
);

const getInitialValue = (): Partial<RegisterBusinessMutationVariables> => {
  return {
    business: {
      type: 'office',
    },
  };
};

export const getBusinessSignupFormFormikConfig = (
  submitFn: (d: RegisterBusinessMutationVariables) => Promise<void>,
): FormikConfig<
  Partial<RegisterBusinessMutationVariables>
> => {
  return {
    initialValues: getInitialValue(),
    enableReinitialize: false,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: signupFormValidationSchema,
    onSubmit: (values) => {
      submitFn(values as RegisterBusinessMutationVariables);
    },
  };
};


